import { store } from "@/store";
import router from "@/router";
import { v4 as uuidv4 } from "uuid";
import { FetchTokenChecking } from "@/components/hook/FetchTokenChecking";
import { handleLogout } from "./utils/logoutHandler";
const tabId = uuidv4();
const HEARTBEAT_KEY = "tab-heartbeats";
const INTERVAL = 2000;
const HEARTBEAT_TIMEOUT = 4000;
const TOKEN_STATUS_KEY = "token-status";

export const initOpenTabHandler = async () => {
  // 현재 페이지가 로그인 페이지인지 확인
  if (window.location.pathname === "/login") {
    return; // 로그인 페이지에서는 초기화하지 않음
  }

  await checkHeartBeat();
  let checkToken = sessionStorage.getItem(TOKEN_STATUS_KEY);

  if (!checkToken && store.getters.JWT) {
    let res = await FetchTokenChecking({ Jwtoken: store.getters.JWT }).response.value;
    checkToken = res.status;
    sessionStorage.setItem(TOKEN_STATUS_KEY, res.status);
  }

  sessionStorage.setItem("tab-alive", "true");

  setInterval(async () => {
    await checkHeartBeat();
  }, HEARTBEAT_TIMEOUT);

  setInterval(() => {
    // 현재 페이지가 로그인 페이지인지 확인
    if (window.location.pathname === "/login") {
      return; // 로그인 페이지에서는 불필요한 체크 건너뛰기
    }

    const beats = JSON.parse(localStorage.getItem(HEARTBEAT_KEY) || "{}");
    beats[tabId] = Date.now();
    localStorage.setItem(HEARTBEAT_KEY, JSON.stringify(beats));
    checkLoginSession();
  }, INTERVAL);

  const checkLoginSession = () => {
    // 현재 페이지가 로그인 페이지인지 다시 한번 확인
    if (window.location.pathname === "/login") {
      return; // 로그인 페이지에서는 체크하지 않음
    }

    const loginSession = localStorage.getItem("login-session");

    if (loginSession) {
      let loginSessionObj = JSON.parse(loginSession);
      if (loginSessionObj?.state == "anonymous") {
        // router.push 대신 window.location.href 사용 (useFullscreen 훅 에러 방지)
        handleLogout();
      }
    }
  };

  window.addEventListener("unload", () => {
    const beats = JSON.parse(localStorage.getItem(HEARTBEAT_KEY) || "{}");
    delete beats[tabId];
    localStorage.setItem(HEARTBEAT_KEY, JSON.stringify(beats));
  });
};

async function checkHeartBeat() {
  // 현재 페이지가 로그인 페이지인지 확인
  if (window.location.pathname === "/login") {
    return; // 로그인 페이지에서는 하트비트 체크하지 않음
  }

  const now = Date.now();
  const beats = JSON.parse(localStorage.getItem(HEARTBEAT_KEY) || "{}");
  const activeTabs = Object.values(beats).filter((ts: number) => now - ts < 4000);
  const isTabAlive = sessionStorage.getItem("tab-alive") == "true";
  if (activeTabs.length === 0 && !isTabAlive) {
    localStorage.removeItem(HEARTBEAT_KEY);
    await store.dispatch("logout");
    // router.push 대신 window.location.href 사용 (useFullscreen 훅 에러 방지)
    await handleLogout();
  }
}
